import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, Text,
  Flex, Card, CardBody, Spinner,
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';

import axiosInstance from '../../../api/AxiosInstance'; 

const DashboardAnuncios = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get('/obras/solicitud-anuncio')
      .then(res => setData(res.data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner size="xl" color="blue.500" />;

  const total = data.length;
  const totalSuperficie = data.reduce((acc, item) => acc + (item.superficie || 0), 0);
  const totalIngreso = data.reduce((acc, item) => acc + (item.costo || 0), 0);

  const tiposAnuncio = data.reduce((acc: any, item) => {
    const tipo = item.tipo || 'Desconocido';
    acc[tipo] = (acc[tipo] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(tiposAnuncio).map(([name, value]) => ({ name, value }));
  const colors = ['#63B3ED', '#48BB78', '#F6AD55', '#ED64A6', '#A0AEC0'];

  return (
    <Box p={6}>
      <Flex justify="center" mb={6}>
        {/* Métricas */}
     

        {/* Gráfica por tipo */}
        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Tipos de Anuncios
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>

      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total de Anuncios</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Superficie Total</StatLabel>
            <StatNumber>{Number(totalSuperficie)} m²</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Ingresos Generados</StatLabel>
            <StatNumber>${Number(totalIngreso).toFixed(2)}</StatNumber>
          </Stat>
        </SimpleGrid>
    </Box>
  );
};

export default DashboardAnuncios;
